<div class="filter">
  <div class="column-options">
    <div *ngFor="let column of columns">
      <!-- <mat-checkbox
        [checked]="selectedColumns.includes(column.code)"
        color="lightGreen"
        (change)="onChange($event, column)"
        >{{ column.name }}</mat-checkbox
      > -->

      <mat-checkbox
        *ngIf="column.filter"
        color="lightGreen"
        [(ngModel)]="column.selected"
        >{{ column.name }}</mat-checkbox
      >
    </div>
  </div>
  <div class="buttons">
    <button mat-button color="lightGreen" [mat-dialog-close]="columns">
      Filter
    </button>
    <button mat-button color="lightGrey" [mat-dialog-close]>Cancel</button>
  </div>
</div>
